import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormInput,
  CLoadingButton,
  CRow,
} from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import PlayerService from 'src/service/PlayerService'
import ExamplePdf from '../../assets/PlayerExternalSampleFile.csv'

const ExternalPlayerImport = () => {
  const [file, setFile] = useState()
  const [array, setArray] = useState([])
  const [errorMessages, setErrorMessages] = useState([])

  const fileReader = new FileReader()

  useEffect(() => {
    if (array.length > 0) {
      const payload = {
        players: array,
      }

      PlayerService.importExternalPlayers(payload).then((res) => {
        if (res.success) {
          setErrorMessages([])
          ToastComponent(res.message, 'success')
        } else {
          setErrorMessages(res.errors || ['Import failed'])
          ToastComponent('Import failed', 'error')
        }
      })
    }
  }, [array])

  const handleOnChange = (e) => {
    setFile(e.target.files[0])
  }

  const csvFileToArray = (string) => {
    const csvHeader = string.slice(0, string.indexOf('\n')).split(',')
    const csvRows = string.slice(string.indexOf('\n') + 1).split('\n')

    const newArray = csvRows.map((i) => {
      const values = i.split(',')
      const obj = csvHeader.reduce((object, header, index) => {
        object[header.trim()] = values[index]?.trim()
        return object
      }, {})
      return obj
    })

    setArray(newArray)
  }

  const handleImport = () => {
    if (file) {
      fileReader.onload = function (event) {
        const text = event.target.result
        csvFileToArray(text)
      }

      fileReader.readAsText(file)
    }
  }

  return (
    <>
      {errorMessages.length > 0 &&
        errorMessages.map((error, index) => (
          <CAlert color="danger" key={index}>
            {error}
          </CAlert>
        ))}

      <CCard className="mb-4">
        <CCardHeader>
          <strong>Player Category Restrictions (PCR)</strong>
        </CCardHeader>

        <CCardBody>
          <CRow>
            <CCol md={6}>
              <CFormInput type="file" accept=".csv" onChange={handleOnChange} />
            </CCol>

            <CCol md={6}>
              <CLoadingButton color="success" variant="outline" onClick={handleImport}>
                Run Import
              </CLoadingButton>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>

      <CCard className="mb-4">
        <CCardHeader>
          <strong>Download Sample File</strong>
          <br></br>
        </CCardHeader>

        <CCardBody>
          <CRow>
            <CCol md={12}>
              <p>
                Easily add players by using the player import tool. Simply create your player list
                in a CSV (Comma Separated Values) format using the format defined below. Once your
                file is ready, upload your CSV file and click {'Run Import'} button.
              </p>
              <p>
                {' '}
                <a
                  href={ExamplePdf}
                  download="Player-External-Sample-CSV.csv"
                  target="_blank"
                  rel="noreferrer"
                >
                  <CButton color={'primary'} variant="outline">
                    Download Sample CSV
                  </CButton>
                </a>
              </p>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </>
  )
}

export default ExternalPlayerImport
